<template>
  <div class="px-4 lg:px-8 py-12 sm:py-32">
    <div class="container">
      <div class="space-y-12 sm:space-y-24">
        <section class="max-w-4xl mx-auto">
          <h1 class="text-3xl sm:text-6xl font-bold">
            {{ $t("site.about.title") }}
          </h1>
          <p class="text-lg sm:text-xl mt-8 sm:mt-12">
            {{ $t("site.about.subtitle") }}
          </p>
        </section>
        <section class="max-w-4xl mx-auto">
          <h1 class="text-2xl sm:text-4xl font-bold">
            {{ $t("site.about.heading1") }}
          </h1>
          <p class="text-base sm:text-xl mt-4 sm:mt-6">
            {{ $t("site.about.para1-1") }}
          </p>
          <p class="text-base sm:text-xl mt-4 sm:mt-6">
            {{ $t("site.about.para1-2") }}
          </p>
          <p class="text-base sm:text-xl mt-4 sm:mt-6">
            {{ $t("site.about.para1-3") }}
          </p>
        </section>
        <section class="max-w-4xl mx-auto">
          <h1 class="text-2xl sm:text-4xl font-bold">
            {{ $t("site.about.heading2") }}
          </h1>
          <p class="text-base sm:text-xl mt-4 sm:mt-6">
            {{ $t("site.about.para2-1") }}
          </p>
          <p class="text-base sm:text-xl mt-4 sm:mt-6">
            {{ $t("site.about.para2-2") }}
          </p>
          <ul
            class="text-base sm:text-xl mt-4 sm:mt-6 space-y-2 list-disc pl-6"
          >
            <li>
              {{ $t("site.about.para2-2-1") }}
            </li>
            <li>
              {{ $t("site.about.para2-2-2") }}
            </li>
            <li>
              {{ $t("site.about.para2-2-3") }}
            </li>
            <li>
              {{ $t("site.about.para2-2-4") }}
            </li>
          </ul>
          <p class="text-base sm:text-xl mt-4 sm:mt-6">
            {{ $t("site.about.para2-3") }}
          </p>
        </section>
        <section class="max-w-4xl mx-auto">
          <h1 class="text-2xl sm:text-4xl font-bold">
            {{ $t("site.about.heading3") }}
          </h1>
          <p class="text-base sm:text-xl mt-4 sm:mt-6">
            {{ $t("site.about.para3-1") }}
          </p>
          <NamiButton
            buttonType="primary"
            :buttonText="$t('site.about.buttonPublish')"
            block
            class="max-w-xs mx-auto mt-4 sm:mt-6"
            :href="`/${locale}/publish`"
          />
        </section>
        <section class="max-w-4xl mx-auto">
          <h1 class="text-2xl sm:text-4xl font-bold">Are you a fan?</h1>
          <p class="text-base sm:text-xl mt-4 sm:mt-6">
            NamiComi will revolutionize the way you interact with creators.
          </p>
          <NamiButton
            buttonType="primary"
            buttonText="Find out how"
            block
            class="max-w-xs mx-auto mt-4 sm:mt-6"
            :href="`/${locale}/fans`"
          />
        </section>
        <section class="max-w-4xl mx-auto">
          <h1 class="text-2xl sm:text-4xl font-bold">
            {{ $t("site.about.heading4") }}
          </h1>
          <ul
            class="text-base sm:text-xl mt-4 sm:mt-6 space-y-2 list-disc pl-6"
          >
            <li>{{ $t("site.about.para4-1") }} hello@namicomi.com</li>
            <li>{{ $t("site.about.para4-2") }} corporate@namicomi.com</li>
          </ul>
        </section>
        <section class="max-w-4xl mx-auto">
          <h1 class="text-2xl sm:text-4xl font-bold">Assets</h1>
          <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-4 sm:mt-6">
            <img src="~/assets/logos/horizontal/normal.png" class="w-full" />
            <img src="~/assets/logos/horizontal/light.png" class="w-full" />
            <img src="~/assets/logos/horizontal/white.png" class="w-full" />
            <img src="~/assets/logos/vertical/normal.png" class="w-full" />
            <img src="~/assets/logos/vertical/light.png" class="w-full" />
            <img src="~/assets/logos/vertical/white.png" class="w-full" />
            <img src="~/assets/logos/logo-transparent.png" class="w-full" />
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const nuxtApp = useNuxtApp();
const { locale } = useI18n();

const seo = {
  title: `About`,
  description:
    "NamiComi is the global ecosystem for creators and fans of comics and manga. We envision a world where creators can achieve global distribution of their comics, and get the financial support they need to continue producing amazing content.",
  //slug: data.attributes.slug,
  coverUrl: "",
  href: `/en/about`,
};

nuxtApp.runWithContext(() =>
  useSeoMeta({
    title: seo.title,
    ogTitle: seo.title,
    twitterTitle: seo.title,
    description: seo.description,
    ogDescription: seo.description,
    twitterDescription: seo.description,
    ogUrl: seo.href,
    ogLocale: locale.value,
    ogImage: seo.coverUrl,
    ogImageSecureUrl: seo.coverUrl,
    twitterImage: seo.coverUrl,
    //ogImageHeight: "1200",
    //ogImageWidth: "630",
    ogImageUrl: seo.coverUrl,
    //ogImageType: "image/png",
    ogImageAlt: "NamiComi",
    ogLocaleAlternate: "en_GB",
  }),
);
</script>
